export default __webpack_public_path__ + "static/media/loss-analysis-step-5-finance.5aab4ebe.gif";